/**
 * The URLs of the launch surface, which the atlas service's `EMR_LAUNCH_*_URL` settings are pointed at.
 *
 * Held as constants because they are named from four places (the route table, the launch page, the
 * login gate, and the re-auth handler) and are a contract with the backend rather than an internal
 * detail: a rename has to be deployed on both sides. The route table spells the segments out, and the
 * routing tests navigate to these constants, so a table that drifted from them fails there.
 */

/** Where a completed launch lands, carrying its single-use handoff code as `?code=`. */
export const LAUNCH_PATH = '/launch'

/**
 * Where a launch that failed for a retryable reason lands, and where an expired EMR-embedded session
 * is sent. Reached with no parameters: the backend logs the reason and shows the user none of it.
 */
export const LAUNCH_ERROR_PATH = '/launch/error'

/** Where a launch that can never succeed for this user lands (an unknown issuer, a denied client). */
export const LAUNCH_UNAUTHORIZED_PATH = '/launch/unauthorized'
